import { useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';

const useTrackingHandler = (iconName = '', departmentLabel) => {
	const { widgetName, windowId } = useRequestData();
	const handler = () => {
		const trackingObj = {
			element: '',
			elementCTA: '',
			result: ''
		};
		switch (iconName) {
			case 'call':
				trackingObj.element = 'Phone number';
				trackingObj.elementCTA = departmentLabel;
				trackingObj.result = 'Call interstitial presented';
				break;
			case 'email':
				trackingObj.element = 'Email Address';
				trackingObj.elementCTA = 'Email Icon';
				trackingObj.result = 'Email dialog opened';
				break;
			case 'info':
				trackingObj.element = 'Info Icon';
				trackingObj.elementCTA = 'Info Button';
				trackingObj.result = 'Info modal opened';
				break;
			// Explicitly handle the case where iconName is null,
			// indicating this handler fn is for a link and not an icon
			case null:
				trackingObj.element = departmentLabel;
				trackingObj.elementCTA = departmentLabel;
				trackingObj.result = `${departmentLabel} staff section`;
				break;
			default:
				break;
		}
		trackEvent(widgetName, windowId, trackingObj);
	};

	return [handler];
};

export default useTrackingHandler;
